// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import "skeleton-css/css/skeleton.css"
import "./src/styles/global.styl"
